import {useLocation} from "react-router-dom";
import React, {useEffect, useMemo, useRef, useState} from "react";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import Box from "@mui/material/Box";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Input,
    Typography
} from "@mui/material";
import ButtonCreate from "../../../components/UI/button/ButtonCreate";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import MenuItem from "@mui/material/MenuItem";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import TextFieldValidation from "../../../components/UI/table/customer-detales/TextFieldValidation";
import ButtonExit from "../../../components/UI/button/ButtonExit";
import ButtonAdd from "../../../components/UI/button/ButtonAdd";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {pictureSystemType} from "../../../data/PictureSystemType";
import AdminPictureService from "../../../API/admin/AdminPictureService";
import NewsSettings from "./NewsSettings";
import UtilityService from "../../../API/common/UtilityService";

const Picture = ({itemId, handleModalAlert}) => {
    const pathname = useLocation().pathname
    const [data, setData] = useState([]);
    const [modal, setModal] = useState(false);
    const [bigImage, setBigImage] = useState(null);
    const [modalSetPicture, setModalSetPicture] = useState(null);
    const allPictureSystemType = Object.entries(pictureSystemType)
    const [currentType, setCurrentType] = useState({type: allPictureSystemType[0][0]});
    const [currentEditRowData, setCurrentEditRowData] = useState(null);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 7,
        searchData: ""
    })
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        getStartPageSize()
        AdminPictureService.get(tableOptions.pageIndex, tableOptions.pageSize, tableOptions.searchData, currentType.type === "ALL" ? null : currentType.type).then(function (response) {
            setData(response.data.content);
            setTableOptions((prev) => ({...prev, totalElements: response?.data.total}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [currentType, tableOptions.searchData, tableOptions.pageIndex, tableOptions.pageSize]);

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}+${itemId}`, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}+${itemId}`]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }

    const handleClose = () => {
        setModal(false)
    }

    const handleDelete = (row) => {
        AdminPictureService.delete(row.id)
            .then(function () {
                setData(prev => prev.filter(el => el.id !== row.id))
                tableOptionsHandle((prev) => ({...prev, totalElements: data.length - 1}))
                handleModalAlert("Данные удалены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
    };

    const handleSubmit = (values, file, handleClose) => {
        setLoading(true)
        AdminPictureService.add(values, file)
            .then(function (response) {
                if (currentType.type === "ALL" || currentType === values.pictureSystemType) {
                    setData(prev => [...prev, response.data])
                    tableOptionsHandle((prev) => ({...prev, totalElements: data.length + 1}))
                }
                handleClose()
                handleModalAlert("Данные добавлены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            }).finally(() => setLoading(false))
    }
    const handleSetPicture = (newsId, priority) => {
        const SetPictureApiMap = {
            "news": AdminPictureService.setNewsPicture,
            "promo": AdminPictureService.setPromoPicture,
            "banner": AdminPictureService.setBannerPicture,
        }
        SetPictureApiMap[modalSetPicture](currentEditRowData.id, newsId, priority)
            .then(function (response) {
                setModalSetPicture(false)
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
    }
    const handleAdd = () => {
        setModal(true)
    }
    const handleSetNews = (row) => {
        setModalSetPicture("news")
        setCurrentEditRowData(row)
    };
    const handleSetPromo = (row) => {
        setModalSetPicture("promo")
        setCurrentEditRowData(row)
    };
    const handleSetBanner = (row) => {
        setModalSetPicture("banner")
        setCurrentEditRowData(row)
    };
    const handleDeleteBanner = (row) => {
        AdminPictureService.deleteBannerPicture(row.id)
            .then(function () {
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
    };

    const columns = useMemo(() => {
        const baseColumns = [
            {
                header: 'Наименование', accessorKey: 'name', minSize: 300,
            },
            {
                header: 'Тип', accessorKey: 'pictureSystemType', minSize: 100,
                Cell: ({cell, row}) => pictureSystemType[cell.getValue()]
            },
            {
                header: 'Картинка', accessorKey: 'relativeUrlSmall', minSize: 100,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return <Box sx={{
                        margin: "4px",
                        height: '100px',
                        width: "170px",
                        borderRadius: "8px",
                        backgroundImage: `url(${value})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        cursor: "pointer"
                    }}
                                onClick={() => setBigImage(row.original.relativeUrl)}/>
                },
            },
        ]

        return baseColumns;

    }, [data]);

    const menuItem = [
        {type: "setPromo", text: "Добавить к акции", handler: handleSetPromo},
        {type: "setNews", text: "Добавить к новости", handler: handleSetNews},
        {type: "setBanner", text: "Добавить к банеру", handler: handleSetBanner},
        {type: "deleteBanner", text: "Удалить из банера", handler: handleDeleteBanner},
        {type: "delete", text: "Удалить", handler: handleDelete}
    ]

    return (<div>
        <Typography sx={{
            fontSize: "24px",
            fontWeight: 700,
            lineHeight: 1
        }}>Изображения</Typography>
        <Box
            sx={{display: 'flex', justifyContent: "space-between", paddingTop: "30px"}}
        >
            <Box sx={{display: 'flex', gap: "20px"}}>
                <Box sx={{width: "300px"}}>
                    <TextFieldValidation
                        select
                        name="type"
                        label="Тип"
                        margin={"none"}
                        value={currentType?.type}
                        setCurrValues={setCurrentType}
                    >
                        {allPictureSystemType.map((option) => (
                            <MenuItem key={option[0]} value={option[0]}>
                                {option[1]}
                            </MenuItem>
                        ))}
                    </TextFieldValidation>
                </Box>
            </Box>
            <ButtonCreate
                text={"Добавить"}
                width={130}
                onClick={handleAdd}
            />
        </Box>
        <MaterialReactTable
            renderTopToolbar={({table}) => {
                return <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "7px",
                    backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                }}>
                    <MRT_ToolbarAlertBanner table={table}/>
                    <Box sx={{display: "flex"}}>
                        <MRT_ToggleFiltersButton table={table}/>
                        <MRT_GlobalFilterTextField table={table}/>
                    </Box>
                </Box>
            }}
            selectAllMode={"all"}
            muiTableContainerProps={{
                sx: {
                    width: '800px',
                    maxHeight: `calc(100vh - 420px)`
                }
            }}
            muiTableBodyCellProps={{
                sx: {
                    p: '0px 0px 0px 10px',
                    m: '0px 0px 0px 0px',
                    border: "none",
                    "& td:after": {
                        "&:hover": {
                            backgroundColor: "red"
                        }
                    },
                    "&:not(:last-of-type)": {
                        borderRight: '1px solid #EAEBEA',

                    },
                    "&:first-of-type": {
                        padding: 0,
                        width: "50px",
                        height: "100px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: (theme) => theme.palette.text.light,
                        "& .MuiButtonBase-root": {
                            borderRadius: "4px",
                            width: "24px",
                            height: "24px",
                            opacity: 1,
                            margin: 0,
                            padding: 0,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            }
                        }
                    },
                    "& li": {
                        listStyleType: "none",
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        }
                    }
                },
            }}
            muiTableHeadCellProps={{
                sx: {
                    border: '1px solid #EAEBEA',
                    backgroundColor: "#F5F6FA",
                    padding: "10px",
                    paddingBottom: " 0.2rem",
                    paddingTop: "0.2rem"
                },
            }}
            muiTableBodyRowProps={({row}) => {
                return ({
                    sx: () => ({
                        height: '36px',
                        backgroundColor: "white",
                        "&:hover& td:after": {
                            display: "none",
                        },
                        "&:hover": {
                            "& td:after": {
                                display: "none",
                            },
                        },
                        '&:nth-of-type(even)': {
                            backgroundColor: (theme) => theme.palette.primary.lightGrey,
                        },
                    })
                })
            }}

            displayColumnDefOptions={{
                'mrt-row-actions': {
                    header: "",
                    size: 3,
                    minSize: 3,
                    grow: false,
                },
            }}
            muiSearchTextFieldProps={{
                placeholder: `Поиск`,
                sx: {
                    paddingTop: "5px",
                    paddingBottom: "0px",
                    "& .MuiCollapse-root": {
                        borderRadius: '12px',
                        height: 40, width: 290,
                        "& .MuiSvgIcon-root": {
                            color: "#737478"
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: 0
                        }
                    }
                },
                variant: 'outlined',
            }}
            columns={columns}
            data={data}
            onGlobalFilterChange={value => tableOptionsHandle({...tableOptions, searchData: value})}
            onPaginationChange={(updater) => {
                tableOptionsHandle(updater(tableOptions));
            }}
            manualPagination={true}
            state={{showGlobalFilter: true, pagination: tableOptions}}
            rowCount={tableOptions.totalElements}
            selectionCss={{
                backgroundColor: 'lightblue',
                borderWidth: '2px',
                borderStyle: 'solid',
                borderColor: 'blue',
                borderRadius: '4px',
            }}
            renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                return <MenuItem
                    key={el.type}
                    onClick={() => {
                        el.handler(row.original)
                        closeMenu();
                    }}
                    sx={{
                        margin: "0 8px",
                        borderRadius: "4px",
                        "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                    }}
                >
                    {el.text}
                </MenuItem>
            })}
            localization={MRT_Localization_RU}
            enableRowActions={true}
            enableToolbarInternalActions={false}
        />
        <NewsSettingsModal
            title={"Добавить"}
            open={modal} onClose={handleClose}
            handleSubmit={handleSubmit}
            allPictureSystemType={allPictureSystemType.slice(1, 4)}
            initValue={{name: "", pictureSystemType: allPictureSystemType[1][0]}}
            loading={loading}
        />
        <BigImage bigImage={bigImage} setBigImage={setBigImage}></BigImage>
        <SetPictureModal
            modalSetPicture={modalSetPicture}
            handleClose={() => setModalSetPicture(null)}
            handleSubmit={handleSetPicture}
            handleModalAlert={handleModalAlert}/>
    </div>);
};
export const SetPictureModal = ({modalSetPicture, handleClose, handleSubmit, handleModalAlert}) => {
    const [selectedString, setSelectedString] = useState({})
    const [banners, setBanners] = useState([])
    const [formState, setFormState] = useState({banner: "", priority: ""})
    const [validationState, setValidationState] = useState({priority: ""})

    useEffect(() => {
        modalSetPicture === "banner" && UtilityService.getBanners().then(function (response) {
            setBanners(response.data);
            setFormState({banner: response.data[0]?.id, priority: ""})
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [modalSetPicture])

    const handleValidationData = () => {
        const newErrors = {...validationState}

        Object.entries(formState).forEach(([name, value]) => {
            if (value === "" && modalSetPicture === "banner") {
                newErrors[name] = "пустое поле"
            }
        })
        setValidationState(newErrors)
        if (Object.values(newErrors).every(el => el === "")) {
            modalSetPicture === "banner" ? handleSubmit(formState?.banner, formState?.priority) : handleSubmit(selectedString?.id)
        }
    }
    return (
        <Dialog open={!!modalSetPicture} PaperProps={{
            style: {
                minWidth: modalSetPicture === "banner" ? "400px" : "810px",
                borderRadius: 8,
            }
        }}
        >
            <DialogTitle
                textAlign="center">{modalSetPicture === "news" ? "Выберите новость" : modalSetPicture === "promo" ? "Выберите акцию" : "Выберите банер"}</DialogTitle>
            <DialogContent>
                {
                    modalSetPicture === "banner" ? <><TextFieldValidation
                        select
                        name="banner"
                        label="Банер"
                        value={formState?.banner}
                        setCurrValues={setFormState}
                    >
                        {banners.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                                {option.name}
                            </MenuItem>
                        ))}
                    </TextFieldValidation><TextFieldValidation
                        name={"priority"}
                        value={formState?.priority}
                        type={"number"}
                        label="Приоритет"
                        setCurrValues={setFormState}
                        validationError={validationState?.priority}
                        setValidationState={setValidationState}
                    /> </> : <NewsSettings
                        itemId={modalSetPicture}
                        handleModalAlert={handleModalAlert}
                        isModal={true}
                        selectedString={selectedString}
                        setSelectedString={setSelectedString}
                    />
                }
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Отменить"} onClick={handleClose}/>
                <ButtonAdd text={"Добавить"}
                           disabled={!selectedString?.id && modalSetPicture !== "banner"}
                           onClick={handleValidationData}/>
            </DialogActions>
        </Dialog>)
}
export const BigImage = ({bigImage, setBigImage}) => {
    return (
        <Dialog open={!!bigImage} PaperProps={{
            style: {
                minWidth: "810px",
                borderRadius: 8,
            }
        }}
        >
            <IconButton
                aria-label="close"
                onClick={() => setBigImage(null)}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 10,
                    top: 10,
                    width: 40,
                    height: 40,
                })}
            >
                <CloseIcon style={{fontSize: 24}}/>
            </IconButton>
            <Box sx={{
                margin: "4px",
                height: '600px',
                width: "800px",
                borderRadius: "8px",
                backgroundImage: `url(${bigImage})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
            }}/>
        </Dialog>)
}

export const NewsSettingsModal = ({
                                      open,
                                      onClose,
                                      handleSubmit,
                                      initValue,
                                      title,
                                      allPictureSystemType,
                                      loading,
                                      editingPictureSystemType = true,
                                      fixedPictureSystemType,
                                  }) => {
    const [formState, setFormState] = useState(initValue)
    const [validationState, setValidationState] = useState({name: ""})
    const [file, setFile] = useState(null)
    const wasOpenRef = useRef(false)

    useEffect(() => {
        if (open && !wasOpenRef.current) {
            setFormState(initValue);
            setFile(null);
            setValidationState({name: ""});
        }
        wasOpenRef.current = open;
    }, [open, initValue]);

    const handleClose = () => {
        setValidationState({name: ""})
        onClose()
        setFile(null)
    }
    const handleValidationData = () => {
        const newErrors = {...validationState}
        Object.entries(formState).forEach(([name, value]) => {
            if (value === "" && name !== "file") {
                newErrors[name] = "пустое поле"
            }
            if (!file) {
                newErrors.file = "Прикрепите фаил"
            }
        })
        setValidationState(newErrors)
        if (Object.values(newErrors).every(el => el === "")) {
            const payload = fixedPictureSystemType
                ? {...formState, pictureSystemType: fixedPictureSystemType}
                : formState;
            handleSubmit(payload, file, handleClose);
        }
    }
    const handleFileSelect = (event) => {
        setFile(event.target.files[0]);
        setValidationState(prev => ({...prev, file: ""}))
    };
    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: "470px",
                borderRadius: 8,
            }
        }}>
            <DialogTitle textAlign="center">{title}</DialogTitle>
            <DialogContent>
                <TextFieldValidation
                    name={"name"}
                    value={formState?.name}
                    label="Наименование"
                    setCurrValues={setFormState}
                    validationError={validationState?.name}
                    setValidationState={setValidationState}
                />
                {editingPictureSystemType && <TextFieldValidation
                    select
                    name="pictureSystemType"
                    label="Тип"
                    value={formState?.pictureSystemType}
                    setCurrValues={setFormState}
                >
                    {allPictureSystemType.map((option) => (
                        <MenuItem key={option[0]} value={option[0]}>
                            {option[1]}
                        </MenuItem>
                    ))}
                </TextFieldValidation>}
                <Box sx={{display: "flex", alignItems: "center", gap: "16px"}}>
                    <label htmlFor={`input`}
                           style={{
                               cursor: "pointer",
                               display: "flex",
                               alignItems: "center",
                               gap: "8px"
                           }}>
                        <AttachFileIcon
                            fontSize="small"
                            sx={{
                                color: (theme) => theme.palette.primary.dark,
                                transform: 'rotate(45deg)',
                            }}/>
                        <Typography sx={{color: (theme) => theme.palette.primary.dark}}>
                            Прикрепить файл</Typography>
                    </label>
                    <Input id={`input`} sx={{display: "none"}} type="file"
                           onChange={handleFileSelect}/>
                    <Typography
                        sx={{fontSize: "16px"}}>
                        {file?.name}
                    </Typography>
                    <Typography
                        sx={{fontSize: "16px", color: (theme) => theme.palette.error.light}}>
                        {validationState.file}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Отменить"} onClick={handleClose}/>
                <ButtonAdd loading={loading} text={"Добавить"} onClick={handleValidationData}/>
            </DialogActions>
        </Dialog>
    );
}
export default Picture;